import { render, staticRenderFns } from "./LatestNews.vue?vue&type=template&id=7a3e2538"
import script from "./LatestNews.vue?vue&type=script&lang=ts"
export * from "./LatestNews.vue?vue&type=script&lang=ts"
import style0 from "./LatestNews.vue?vue&type=style&index=0&id=7a3e2538&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports